import Vue from 'vue';
import Vuex from 'vuex';
// import 'es6-promise/auto';
import layout from './modules/layout';
import menu from './modules/menu';
import { alert } from './modules/alert';
import { authentication } from './modules/authentication';
import { users } from './modules/users';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
      language : 'en'
    },
    mutations: {
      changeLang (state, payload) {
        state.language = payload.id;
        localStorage.setItem('currentLanguage', payload.id);
        localStorage.setItem('currentLanguageIcon', payload.icon);
        //window.location.reload();
      }
    },
    actions: {
      setLang ({ commit }, payload) {
        commit('changeLang', payload);
      }
    },
    modules: {
      alert,
      authentication,
      users,
      layout,
      menu,
    }
});

